import { render, staticRenderFns } from "./ModalOrderdespachador.vue?vue&type=template&id=6371e7ae&scoped=true&"
import script from "./ModalOrderdespachador.vue?vue&type=script&lang=js&"
export * from "./ModalOrderdespachador.vue?vue&type=script&lang=js&"
import style0 from "./ModalOrderdespachador.vue?vue&type=style&index=0&id=6371e7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371e7ae",
  null
  
)

export default component.exports